import { useState, useEffect } from "react";
import { useAuth } from "@/contexts/AuthContext";
import { TicketsList, NewTicketForm, TicketDetail } from "@/components/tickets/TicketsModule";
import { TicketsDashboard } from "@/components/tickets/TicketsDashboard";
import { TicketConfig } from "@/components/tickets/TicketConfig";
import { TicketsSurveyPanel } from "@/components/tickets/TicketsSurveyPanel";

export const TicketsAdmin = ({ onSelectTicket, onNewTicket, user, initialTab, onTabReset }) => {
  const isAdmin = user?.role === "admin";
  const [tab, setTab] = useState("lista");

  useEffect(() => {
    if (initialTab) {
      setTab(initialTab);
      onTabReset?.();
    }
  }, [initialTab]);

  return (
    <div>
      <div className="flex gap-1 mb-6 bg-slate-100 p-1 rounded-lg w-fit" data-testid="tickets-admin-tabs">
        <button onClick={() => setTab("lista")}
          className={`px-4 py-2 text-sm font-medium rounded-md transition-colors ${tab === "lista" ? "bg-white text-slate-900 shadow-sm" : "text-slate-500 hover:text-slate-700"}`}
          data-testid="tickets-tab-lista">
          Lista de Tickets
        </button>
        {isAdmin && (
          <button onClick={() => setTab("dashboard")}
            className={`px-4 py-2 text-sm font-medium rounded-md transition-colors ${tab === "dashboard" ? "bg-white text-slate-900 shadow-sm" : "text-slate-500 hover:text-slate-700"}`}
            data-testid="tickets-tab-dashboard">
            Dashboard
          </button>
        )}
        {isAdmin && (
          <button onClick={() => setTab("config")}
            className={`px-4 py-2 text-sm font-medium rounded-md transition-colors ${tab === "config" ? "bg-white text-slate-900 shadow-sm" : "text-slate-500 hover:text-slate-700"}`}
            data-testid="tickets-tab-config">
            Configuracion
          </button>
        )}
        {isAdmin && (
          <button onClick={() => setTab("encuestas")}
            className={`px-4 py-2 text-sm font-medium rounded-md transition-colors ${tab === "encuestas" ? "bg-white text-slate-900 shadow-sm" : "text-slate-500 hover:text-slate-700"}`}
            data-testid="tickets-tab-encuestas">
            Encuestas
          </button>
        )}
      </div>
      {tab === "lista" && (
        <>
          <h1 className="text-2xl font-bold text-slate-900 mb-6">Mis Tickets</h1>
          <TicketsList onSelectTicket={onSelectTicket} onNewTicket={onNewTicket} />
        </>
      )}
      {tab === "dashboard" && isAdmin && <TicketsDashboard />}
      {tab === "config" && isAdmin && <TicketConfig />}
      {tab === "encuestas" && isAdmin && <TicketsSurveyPanel />}
    </div>
  );
};
